import configuration from './configuration';
import individual from './individual';

export default {
  configuration,
  individual,
};
